type CSImageAlignment = 'left' | 'right'

const HK_SG_IMAGES: Record<CSImageAlignment, Record<string, App.Image>> = {
  left: {
    wide: { id: '9zfajijv2lx81f6gyfo' },
    narrow: { id: 'mxv1ewoo3pe8l8ddl4e' },
  },
  right: {
    wide: { id: '56l0glrmixeitosoetkn9' },
    narrow: { id: 'us3u14wkihlv6zs4anuh' },
  },
}

const DEFAULT_IMAGES: Record<CSImageAlignment, Record<string, App.Image>> = {
  left: {
    wide: { id: 'f2cbkfa3neeqk0suw16u' },
    narrow: { id: 'l2rjsmuqvmafzqn1p2p' },
  },
  right: {
    wide: { id: 'kra2y9app8i6mpnli' },
    narrow: { id: 'd5sfjdbpg47k0yfcxxzj' },
  },
}

function getCustomerSupportAgentImage(
  alignment: CSImageAlignment,
  isWideImage: boolean,
  region: string,
): App.Image {
  const images = region === 'HK' || region === 'SG' ? HK_SG_IMAGES : DEFAULT_IMAGES

  if (alignment === 'right') {
    return isWideImage ? images.right.wide : images.right.narrow
  } else {
    return isWideImage ? images.left.wide : images.left.narrow
  }
}

export default getCustomerSupportAgentImage
